import React, { useEffect } from 'react'
import './Skills.scss'
import { motion } from 'framer-motion'
import {Tooltip} from 'react-tooltip'
import { client, urlFor } from '../../client'
import { useState } from 'react'
import { AppWrap, MotionWrap } from '../../wrapper'
import { useNavigate } from 'react-router-dom'

const Skills = () => {

  const [skills, setSkills] = useState([])
  const [experiences, setExperiences] = useState([])
  const navigate = useNavigate()

  useEffect(() => {
    const query = '*[_type == "experiences"]'
    const querySkills = '*[_type == "skills"]'

    client.fetch(querySkills)
    .then((data)=> {
      setSkills(data)
      
    })

    client.fetch(query)
    .then((data)=> {
      setExperiences(data)
     
    })
  
   
  }, [])

  const navTo=(item)=>{
    navigate("/skilldetails", {state:item})
  }
  
  return (
    <>
      <h2 className='head-text'>Skills and Experience</h2>

      <div className="app__skills-container">
        <motion.div 
        className='app__skills-list'>
          {skills.map((skill)=>(
            <motion.div
            whileInView={{opacity:[0, 1]}}
            transition={{duration: 0.5}}
            className="app__skills-item app__flex"
            key={skill.name}>
            <div className="app__flex" style={{backgroundColor:skill.bgColor}}>
              <img src={urlFor(skill.icon)} alt={skill.name} />

            </div>
            <p className='p-text'>{skill.name}</p>
            </motion.div> 
          ))}
        </motion.div>

        <motion.div className='app_skills-exp'>
          {experiences.map((experience)=>(
           <motion.div
           onClick={()=>navTo(experience)}
           className='app__skills-exp-item' key={experience.year}>
            <div className="app__skills-exp-year">
              <p className='bold-text'>{experience.year}</p>
            </div>
            <motion.div className='app_skills-exp-works'>

            {experience.works.map((work)=>(
              <>
              <motion.div 
              
              whileInView={{opacity: [0,1]}}
              transition={{duration: 0.5}}
              className="app__skills-exp-work"
              data-tip
              data-for={work.name}
              key={work.name}
              >
                <h4 className='bold-text'>{work.name}</h4>
                <p className='p-text'>{work.company}</p>
              </motion.div>
              <a data-tooltip-id="my-tooltip" >{work.technology}</a>
              <Tooltip 
              id="my-tooltip"
              
              />
                
             

             
            </>
            ))}

             </motion.div> 

            </motion.div>
          ))}
        </motion.div> 
      </div>
    </>
  )
}

export default AppWrap(MotionWrap(Skills,'app__skills'), 'skills', 'app__whitebg')